import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import ProjectInformationPage from "../../../Containers/ProjectInformationPage";
import { useEffect, useState } from "react";
import {
  GetExpectedProjectImpact,
  SetExpectedProjectImpact,
  ValidateExpectedProjectImpact,
} from "../../../Redux/Reducers/ProjectInformationPage/ExpectedProjectTargetGroupModule";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import UpdateProjectImpact from "../../../Services/ProjectInformationPage/ExpectedUnoactProjectTargetGroup/UpdateProjectImpact";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loadConfig from "../../../Services/apiService";
import PopupAHSF from "../../../Components/PopupAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const ExpectedUnoactProjectTargetGroupModule = () => {
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ExpectedProjectImpact: state.ExpectedProjectImpact.ExpectedProjectImpact,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      loadingGetExpectedProjectImpact:
        state.ExpectedProjectImpact.loadingGetExpectedProjectImpact,
      ExpectedProjectImpactValidate:
        state.ExpectedProjectImpact.ExpectedProjectImpactValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });
  const navigate = useNavigate();
  // Local state for managing expected project impact
  const [expectedProjectImpact, setExpectedProjectImpact] = useState({
    // expectedSocialImpact: state.ExpectedProjectImpact?.expectedSocialImpact,
    // knowledgeTransferPlan: state.ExpectedProjectImpact?.knowledgeTransferPlan,
    // projectImpactOnTargetGroupSkillsAcquired:
    //   state.ExpectedProjectImpact?.projectImpactOnTargetGroupSkillsAcquired,
    // projectSustainabilityPlan:
    //   state.ExpectedProjectImpact?.projectSustainabilityPlan,

    ...state.ExpectedProjectImpact,
  });
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };

  //console.log(state.ExpectedProjectImpact, "expectedProjectImpact");
  // Load Expected Project Impact when component mounts
  useEffect(() => {
    dispatch(
      GetExpectedProjectImpact(
        state.ApplicationInformation.aI_ApplicationInformationId ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);
  // Save data and optionally validate
  const SaveDataPage = async (withValidate) => {
    const saved = await UpdateProjectImpact(
      state.ExpectedProjectImpact?.pI_ExpectedProjectImpactOnTargetGroupId,
      expectedProjectImpact.expectedSocialImpact,
      expectedProjectImpact.projectImpactOnTargetGroupSkillsAcquired,
      expectedProjectImpact.projectSustainabilityPlan,
      expectedProjectImpact.knowledgeTransferPlan,

      expectedProjectImpact.aI_ApplicationInformationId
    );
    if (withValidate == true && saved) {
      const validate = await dispatch(
        ValidateExpectedProjectImpact(
          state.ExpectedProjectImpact.aI_ApplicationInformationId
        )
      );
      if (validate.payload.length === 0) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم حفظ المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        navigate("/grants/InformationProject/sectorInfo");
      } else {
        setisPopupOpenStatus(true);
      }
    }
  };
  // Update local state when data is loaded
  useEffect(() => {
    if (!state.loadingGetExpectedProjectImpact) {
      setExpectedProjectImpact({ ...state.ExpectedProjectImpact });
    }
  }, [state.loadingGetExpectedProjectImpact]);
  // Update Redux state when local state changes
  useEffect(() => {
    dispatch(SetExpectedProjectImpact({ ...expectedProjectImpact }));
  }, [expectedProjectImpact]);
  // //console.log(state.ProjectInformation, "add", projectInformation);
  const shouldDisableFields = !(
    //[,]
    // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
    (
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    )
  );
//render html after loading ends
  return (
    <>
      <ProjectInformationPage active={3} />
      {!state.loadingGetExpectedProjectImpact ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="الأثر المتوقع للمشروع على الفئة المستهدفة ومعايير الاستدامة "
            child={[
              <div className="form-grid">
                <TextAreaAHSF
                  fieldsName="ExpectedImpact"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ExpectedProjectImpact?.expectedSocialImpact
                  }
                  onChange={(e) => {
                    setExpectedProjectImpact({
                      ...expectedProjectImpact,
                      expectedSocialImpact: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ExpectedProjectImpactValidate
                      ? state.ExpectedProjectImpactValidate.includes(
                          "ExpectedImpact"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="TargetSkillsImpact"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ExpectedProjectImpact
                      ?.projectImpactOnTargetGroupSkillsAcquired
                  }
                  onChange={(e) => {
                    setExpectedProjectImpact({
                      ...expectedProjectImpact,
                      projectImpactOnTargetGroupSkillsAcquired: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ExpectedProjectImpactValidate
                      ? state.ExpectedProjectImpactValidate.includes(
                          "TargetSkillsImpact"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="ProjectContinuationPlan"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ExpectedProjectImpact?.projectSustainabilityPlan
                  }
                  onChange={(e) => {
                    setExpectedProjectImpact({
                      ...expectedProjectImpact,
                      projectSustainabilityPlan: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ExpectedProjectImpactValidate
                      ? state.ExpectedProjectImpactValidate.includes(
                          "ProjectContinuationPlan"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="KnowledgeSharing"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ExpectedProjectImpact?.knowledgeTransferPlan
                  }
                  onChange={(e) => {
                    setExpectedProjectImpact({
                      ...expectedProjectImpact,
                      knowledgeTransferPlan: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ExpectedProjectImpactValidate
                      ? state.ExpectedProjectImpactValidate.includes(
                          "KnowledgeSharing"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>,
            ]}
          />
          {!shouldDisableFields ? (
            <div className="containerButtonMAin">
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  SaveDataPage(false);
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "تم حفظ المعلومات بنجاح",
                    showConfirmButton: false,
                    timer: 1500,
                    // width: "500px",
                  });
                }}
                disabled={false}
                title={"حفظ"}
                text={"حفظ"}
                show={true}
              />
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  SaveDataPage(true);
                }}
                disabled={false}
                title={"التالي"}
                text={"التالي"}
                show={true}
              />
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingGetExpectedProjectImpact} />
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.ExpectedProjectImpactValidate}
      />
    </>
  );
};

export default ExpectedUnoactProjectTargetGroupModule;
